import React, { useEffect, useState } from "react";

import {
    Box,
    Typography,
    CircularProgress,
    Alert
} from "@mui/material";

import WelcomeCard from "../components/dashboard/WelcomeCard";
import StatisticsGrid from "../components/dashboard/StatisticsGrid";
//import RecentActivity from "../components/dashboard/RecentActivity";
//import SyncStatus from "../components/dashboard/SyncStatus";
//import QuickActions from "../components/dashboard/QuickActions";

import dashboardAPI from "../api/dashboard";

export default function Dashboard() {

    const [stats, setStats] = useState(null);
    const [activity, setActivity] = useState([]);
    const [sync, setSync] = useState(null);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    const loadDashboard = async () => {

        try {

            setLoading(true);

            const [

                statistics,

                recentActivity,

                syncStatus

            ] = await Promise.all([

                dashboardAPI.getStatistics(),

                dashboardAPI.getRecentActivity(),

                dashboardAPI.getSyncStatus()

            ]);

            setStats(statistics);

            setActivity(recentActivity);

            setSync(syncStatus);

            setError("");

        }

        catch (err) {

            console.error(err);

            setError("Unable to load dashboard.");

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadDashboard();

    }, []);

    if (loading) {

        return (

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 10
                }}
            >

                <CircularProgress />

            </Box>

        );

    }

    if (error) {

        return (

            <Alert severity="error">

                {error}

            </Alert>

        );

    }

    return (

        <Box>

            <Typography

                variant="h4"

                fontWeight="bold"

                gutterBottom

            >

                Dashboard

            </Typography>

            <WelcomeCard />

            


        </Box>

    );

}